export default __webpack_public_path__ + "static/media/bg-gif.02f2236f.gif";